import BAInput from "./BAInput";

function BATextarea(props) {
  const { label, rows, value, onChange, variant } = props;
  return (
    <>
      <BAInput
        variant={variant}
        value={value}
        onChange={onChange}
        multiline={true}
        rows={rows ? rows : 3}
        label={label}
      />
    </>
  );
}

export default BATextarea;
